import { Component, OnInit } from '@angular/core';
import { RootMixin, UserAwareMixin } from '@asp/mixins';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-view-menu',
  templateUrl: './view-menu.component.html',
  styleUrls: ['./view-menu.component.scss'],
})
export class ViewMenuComponent
  extends UserAwareMixin(RootMixin)
  implements OnInit
{
  luser: Observable<any>;
  constructor() {
    super();
  }

  ngOnInit(): void {
    this.luser = this.currentUser.valueChanges.pipe(
      map((res: any) => res.data.currentUser),
    );
  }
}
